import { useAuth } from 'context/AuthContext';
import { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import ReactModal from 'react-modal';

import badgeAnimation from 'assets/lottie/trophy.json';
import { IoIosClose } from 'react-icons/io';

export function AchievementModal(props: any) {
  // const modalID = "achievement";

  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalData, setModalData] = useState<any>();
  const { refreshUser, user } = useAuth();
  // const { openModal, closeModal } = useContext(ModalContext);
  // const { children } = props;

  ReactModal.setAppElement('#modal-achievement');

  function handleCloseModal() {
    setIsOpen(false);
  }

  function afterOpenModal() {
    //
  }

  useEffect(() => {
    const listener = async ({ data }: any) => {
      if (data.type === 'achievement') {
        setIsOpen(true);
        setModalData(data.value);
        refreshUser();
      }
    };
    window.addEventListener('message', listener);
    return () => {
      window.removeEventListener('message', listener);
    };
  }, [refreshUser]);

  if (!user) return null;

  return (
    <>
      <ReactModal
        shouldCloseOnOverlayClick={false}
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={handleCloseModal}
        contentLabel="Parabéns"
        portalClassName="relative z-50"
        overlayClassName="rb-modal-overlay"
        contentElement={() => (
          <div className="rb-modal rb-modal--sm" style={{ textAlign: 'center' }}>
            <button className="rb-modal__close" aria-label="Fechar" onClick={() => handleCloseModal()}>
              <IoIosClose size={26} />
            </button>

            <div className="rb-modal__header">
              <h1 className="rb-modal__title">Parabéns!</h1>
              {!modalData?.name && <p className="rb-modal__subtitle">Você jogou!</p>}
              {modalData?.name && (
                <p className="rb-modal__subtitle" style={{ color: 'var(--blue-primary)', fontWeight: 700 }}>
                  {modalData?.name}
                </p>
              )}
            </div>

            <div style={{ width: 260, margin: '0 auto' }}>
              <Lottie animationData={badgeAnimation} loop={true} />
            </div>

            <div className="rb-modal__actions">
              <button className="rb-btn-primary" onClick={() => handleCloseModal()}>
                Fechar
              </button>
            </div>
          </div>
        )}
      />
    </>
  );
}
